﻿/*****
    Author:	    CT Software Systems, LLC
    Last Modified: 251029 
    This script contains functions used for data validation
*/
'use strict';

let _isModified = false;

const confirmedPW = (params = {}) => {

    const {
        pwCtrl = 'editPW',
        confirmPwCtrl = 'editConfirmPW',
        errColor = 'red',
        confirmPWErrMsgId
    } = params;

    const pw = $(`#${pwCtrl}`).val();
    const confirmPW = $(`#${confirmPwCtrl}`).val();
    const isValid = pw === confirmPW;

    if (!confirmPWErrMsgId) {
        isValid
            ? $(`#${confirmPWErrMsgId}`).addClass('hidden')
            : $(`#${confirmPWErrMsgId}`).removeClass('hidden').css('color', errColor);
    }
    return isValid;
};

const enableBtn = (params = {}) => {
        const {
            isEnabled = true,
            requiredCtrlNms = [],
            btnNm
        } = params;

        let enabled = isEnabled;
        if (params.isEnabled === undefined) {
            // All passed in controls must have a value entered in them
            for (let i = 0, l = requiredCtrlNms.length; i < l; i++) {
                if ($(requiredCtrlNms[i]).val().length === 0) {
                    enabled = false;
                }
            }
        }
        enabled
            ? $(btnNm).removeAttr('disabled')
            : $(btnNm).prop('disabled', true);
    };

const hasCheckedItems = ({ idPrefix = "cb_" } = {}) => 
    $(`input[id^="${idPrefix}"]:checked`).length > 0;

const integerOnly = (e) => { /* Used onkeypress event */
    const key = e.which ? e.which : event.keyCode;
    return key < 48 || key > 57 ? false : true;
};

const isDataModified = () => _isModified; 

const missingRequiredData = (params = {}) => {
    // dataItems { ctrlNm: '#editName', labelText: 'Name' } 
    // displayMsg: set to false if user message is not to be displayed
    // such as when this is used to enable a submit button
    // or called from an onkeyup event with code to enable the submit button

    const errId = params.errMsgId ?? 'divErrMsg';
    if (!params.dataItems) {
        $(`#${errId}`).text('dataItems must be defined to use this function...').removeClass('hidden');
        return true;
    }
    let missingData = false;
    if (params.displayMsg === false) {
        for (const item of params.dataItems) {
            const value = $(item.ctrlNm).val();
            if (value.length === 0) {
                missingData = true;
                break;
            }
        }
    } else {
        let eMsg = '';
        let eMsgCnt = 0;
        for (const item of params.dataItems) {
            const value = $(item.ctrlNm).val();
            if (value.length === 0) {
                eMsgCnt += 1;
                eMsg += `${item.labelText}, `;
            }
        }
        if (eMsg.length > 0) {
            eMsg = eMsg.slice(0, -2);
            eMsg += (eMsgCnt > 1) ? ' are required...' : ' is required...';
            $(`#${errId}`).text(eMsg).removeClass('hidden');
            missingData = true;
        } else {
            $(`#${errId}`).text(eMsg).addClass('hidden');
        }
    }

    return missingData;
};
const numberOnly = (e) => { /* Used onkeypress event */
    const key = e.which ? e.which : e.keyCode;
    const char = String.fromCharCode(key);
    // Allow only digits and a single dot (if not already present in the input)
    if (!/[\d.]/.test(char)) return false;
    if (char === '.' && e.target.value.includes('.')) return false;
    return true;
};
const phoneNumberInputMask = (params) => {
    if (params === undefined || params.format === '(999) 999-9999') {
        return (e) => {
            const x = e.target.value.replace(/\D/g, '').match(/(\d{0,3})(\d{0,3})(\d{0,4})/);
            e.target.value = !x[2] ? x[1] : '(' + x[1] + ') ' + x[2] + (x[3] ? '-' + x[3] : '');
        };
    }
}

const setModified = bModified => _isModified = bModified; 

const validEmail = (params = {}) => {
    const {
        email,
        emailCtrl = 'editEmail',
        errColor = 'red',
        divErrMsgId
    } = params;

    const emailValue = email ?? $(`#${emailCtrl}`).val();
    if (!emailValue || emailValue.length === 0) return;

    const regex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    const isValid = regex.test(emailValue);

    if (divErrMsgId) {
        isValid
            ? $(`#${divErrMsgId}`).addClass('hidden')
            : $(`#${divErrMsgId}`).removeClass('hidden').css('color', errColor);
    }
    return isValid;
};

const validPW = (params = {}) => {
    const {
        pwCtrl = 'editPW',
        color = 'green',
        errColor = 'red',
        minQty,
        minLenMsgId,
        uppercaseMsgId,
        lowercaseMsgId,
        numberMsgId,
        specialCharMsgId
    } = params;
    const pw = $(`#${pwCtrl}`).val();
    let isValidPW = true;

    if (minQty && minLenMsgId) {
        const isInvalid = pw.length < minQty;
        $(`#${minLenMsgId}`).css("color", isInvalid ? errColor : color);
        isValidPW = isValidPW && !isInvalid;
    }
    if (uppercaseMsgId) {
        const isInvalid = pw.search(/[A-Z]/) === -1;
        $(`#${uppercaseMsgId}`).css("color", isInvalid ? errColor : color);
        isValidPW = isValidPW && !isInvalid;
    }
    if (lowercaseMsgId) {
        const isInvalid = pw.search(/[a-z]/) === -1;
        $(`#${lowercaseMsgId}`).css("color", isInvalid ? errColor : color);
        isValidPW = isValidPW && !isInvalid;
    }
    if (numberMsgId) {
        const isInvalid = pw.search(/\d/) === -1;
        $(`#${numberMsgId}`).css("color", isInvalid ? errColor : color);
        isValidPW = isValidPW && !isInvalid;
    }
    if (specialCharMsgId) {
        const isInvalid = pw.search(/[^\w\s]/) === -1;
        $(`#${specialCharMsgId}`).css("color", isInvalid ? errColor : color);
        isValidPW = isValidPW && !isInvalid;
    }
    return isValidPW;
};
const validURL = (params = {}) => {

    const {
        url,
        urlCtrl = 'editURL',
        errColor = 'red',
        divErrMsgId
    } = params;

    const urlValue = url ?? $(`#${urlCtrl}`).val();
    if (!urlValue || urlValue.length === 0) return;

    const regex = new RegExp('^(https?:\\/\\/)?' + // protocol
        '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.?)+[a-z]{2,}|' + // domain name
        '((\\d{1,3}\\.){3}\\d{1,3}))' + // ip (v4) address
        '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*' + //port
        '(\\?[;&amp;a-z\\d%_.~+=-]*)?' + // query string
        '(\\#[-a-z\\d_]*)?$', 'i');
    const isValid = regex.test(urlValue);

    if (divErrMsgId) {
        isValid
            ? $(`#${divErrMsgId}`).addClass('hidden')
            : $(`#${divErrMsgId}`).removeClass('hidden').css('color', errColor);
    }
    return isValid;
};


export {
    confirmedPW, enableBtn, hasCheckedItems, isDataModified,
    integerOnly, missingRequiredData, numberOnly, phoneNumberInputMask,
    setModified, validEmail, validPW, validURL
};
